import { Theme } from "@emotion/react";
import { colors } from "./colors";
import { typography } from "./typography";
import { icons } from "./icons";
import { animations } from "./animations";
import { images } from "./images";
import {videos} from "./videos";

export const theme: Theme = {
  colors: colors,
  typography: typography,
  icons: icons,
  animations: animations,
  images: images,
  videos: videos
};
